import { deleteDoc, doc } from "firebase/firestore"
import { deleteObject, getStorage, listAll, ref } from "firebase/storage"
import { db } from "../firebase/config"

/**
 * Cleans up a Viva plate when its order is completed.
 * Only runs when the order machine is "Viva" — safe to call for any order.
 *
 * Steps:
 *  1. Deletes all files from Firebase Storage at vivaPlates/{plateCode}/
 *  2. Deletes the plate document from vivaPlateList
 *
 * Arsoma and Tape plates are left untouched.
 *
 * @param {object} order - Full order object
 * @returns {Promise<void>}
 */
export const cleanupVivaPlate = async (order) => {
  if (order?.selectedProduct?.machine !== "Viva") return

  const plateCode = order.selectedPlate?.code
  const plateId = order.selectedPlate?.id

  if (!plateCode || !plateId) return

  // 1. Delete all files in vivaPlates/{plateCode}/
  try {
    const storage = getStorage()
    const folderRef = ref(storage, `vivaPlates/${plateCode}`)
    const { items } = await listAll(folderRef)
    await Promise.all(items.map((fileRef) => deleteObject(fileRef)))
  } catch (err) {
    console.error(`[cleanupVivaPlate] Storage cleanup failed for plate ${plateCode}:`, err)
  }

  // 2. Remove the plate document from vivaPlateList
  try {
    await deleteDoc(doc(db, "vivaPlateList", plateId))
  } catch (err) {
    console.error(`[cleanupVivaPlate] Firestore delete failed for plate ${plateId}:`, err)
  }
}
